import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-investigation-subtask-notes',
  templateUrl: './investigation-subtask-notes.component.html',
  styleUrls: ['./investigation-subtask-notes.component.scss'],
})
export class InvestigationSubtaskNotesComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  title: any;
  claimId: any;
  idInvestigationSubtask: any;
  showUpload: boolean = false;
  claimAuthority: any;
  addIcon = this.RESOURCE_SERVER_URL + '/assets/images/addPurple.svg';
  editIcon = this.RESOURCE_SERVER_URL + '/assets/images/Edit.svg';
  deleteIcon = this.RESOURCE_SERVER_URL + '/assets/images/Delete.svg';
  uploadIcon =
    this.RESOURCE_SERVER_URL +
    '/assets/images/process-claims/icons/upload_file.svg';
  value: any;
  isLoading: boolean = false;
  notes: any;
  editList: any = [];
  deleteList: any = [];
  anotation=[]
  notesSelect: any;
  isDialogUpload: boolean = false;

  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<InvestigationSubtaskNotesComponent>,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit(): void {
    console.log('this is data ', this.data);
    this.claimId = this.data.claimID;
    this.idInvestigationSubtask = this.data.idInvestigationSubtask;
    this.claimAuthority = JSON.parse(localStorage.getItem('claimAuthority'));
    this.getInvestigationNotesList();
    this.title = this.data.title;
    this.showUpload = this.data.showUpload;
  }
  async getInvestigationNotesList() {
    this.isLoading = true;
    try {
      let url =
        environment.API_CLAIM_OFFICE_SERVER_URL +
        this.claimId +
        '/investigationSubtask/' +
        this.idInvestigationSubtask +
        '/investigationNotes';
      let response = await this.commonService.commonGet(url);
      this.notes = response.body.content;
      if (this.notes == undefined) this.notes = [];
      else {
        for (let item of this.notes) {
          item.isEdit = false;
        }
      }
    let res = await this.commonService.commonGet(`${environment.API_CLAIM_REGISTRATION_SERVER_URL}${this.claimId}/anomalies/notes`);
    if(res){
      this.anotation=res.body._links.item
    }
      this.isLoading = false;
    } catch (err) {
      console.log('investigationSubtask List err', err);
      this.isLoading = false;
    }
  }

  async onDataBlur(data, index: number) {
    this.isLoading = true;
    let body = {};
    body['notesDesc'] = this.notes[index].notesDesc;
    try {
      let url =
        environment.API_CLAIM_OFFICE_SERVER_URL +
        this.claimId +
        '/investigationSubtask/' +
        this.idInvestigationSubtask +
        '/investigationNotes/' +
        this.notes[index].uuid;
      await this.commonService.commonPatch(url, body);
      this.isLoading = false;
    } catch (err) {
      console.log('patch claim notes List err', err);
      this.isLoading = false;
    }
  }

  async onCloseDialog() {
    this.dialogRef.close();
  }

  async onApproveTask() {
    this.isLoading = true;
    let body = { isApproved: 'Y', status: 'Completed', userId: localStorage.getItem('assignedToUser') };
    try {
      let url =
        environment.API_CLAIM_OFFICE_SERVER_URL +
        this.claimId +
        '/investigationSubtask/' +
        this.idInvestigationSubtask;
      let res = await this.commonService.commonPatch(url, body);
      this.isLoading = false;
    } catch (err) {
      console.log('investigationSubtask approveTask err', err);
      this.isLoading = false;
    }
    this.dialogRef.close('Y');
  }

  onChange(event, index: number) {
    this.notes[index].notesDesc = event.value;
  }
  async onAddNote() {
    this.isLoading = true;
    let body = {};
    try {
      let url =
        environment.API_CLAIM_OFFICE_SERVER_URL +
        this.claimId +
        '/investigationSubtask/' +
        this.idInvestigationSubtask +
        '/investigationNotes';
      let res = await this.commonService.commonPost(url, body);
      await this.getInvestigationNotesList();
      this.isLoading = false;
    } catch (err) {
      console.log('investigationSubtask create addnote err', err);
      this.isLoading = false;
    }
  }

  async onDeleteNote(index: number) {
    this.isLoading = true;
    let notesId = this.notes[index].uuid;
    try {
      let url =
        environment.API_CLAIM_OFFICE_SERVER_URL +
        this.claimId +
        '/investigationSubtask/' +
        this.idInvestigationSubtask +
        '/investigationNotes/' +
        notesId;
      let response = await this.commonService.commonDelete(url);

      await this.getInvestigationNotesList();
      this.isLoading = false;
    } catch (err) {
      console.log('Delete List err', err);
      this.isLoading = false;
    }
  }
  async onEditNote(index: number) {
    if (!this.notes[index].isEdit) {
      this.editList.push({ uuid: this.notes[index].uuid });
      this.notes[index].isEdit = true;
    }
  }

  onFileUpload(item) {
    this.notesSelect = item;
    this.isDialogUpload = !this.isDialogUpload;
  }

  async onUploadFile(event) {
    console.log(event);
    this.isLoading = true;
    try {
      let formData: FormData = new FormData();
      let typeFile = event[0].data.type;
      if (
        typeFile == 'application/pdf' ||
        typeFile == 'image/png' ||
        typeFile == 'image/jpeg'
      ) {
        formData.append('file', event[0].data);
        await this.uploadDocument(formData);
      }
      this.isLoading = false;
    } catch (error) {
      console.log('Upload File Failed:', error);
      this.isLoading = false;
    }
    this.isDialogUpload = false;
  }

  async uploadDocument(formData: FormData) {
    // Post API - Uploading document.
    try {
      let url =
        environment.API_CLAIM_OFFICE_SERVER_URL +
        this.claimId +
        '/investigationSubtask/' +
        this.idInvestigationSubtask +
        '/investigationNotes/' +
        this.notesSelect.uuid +
        '/documentUpload';
      let res = await this.commonService.commonPost(url, formData);
      await this.getInvestigationNotesList();
    } catch (err) {
      console.log('Upload Document Error', err);
    }
  }
  supperlogin(){
    let showfraudPercentage=false;
    let authority=JSON.parse(localStorage.getItem('claimAuthority'))
    if(authority&& authority!=null){
      showfraudPercentage=authority['assessor'].actions.Yes?true:false}
      return showfraudPercentage
  }
}
